<template>
  <div class="material-like">
    <h5>была ли статья полезна?</h5>
    <button
      :class="['m-btn material-like__like', { active: like }]"
      @click="setLike"
    >
      полезно
      <img
        src="/img/materials/material/like.svg"
        alt="link"
      >
    </button>
    <button
      :class="['m-btn material-like__dislike', { active: dislike }]"
      @click="setDislike"
    >
      непонятно
      <img
        src="/img/materials/material/dislike.svg"
        alt="link"
      >
    </button>
  </div>
</template>

<script>
const LIKES_STORAGE_KEY = 'LIKE_MATERIALS';
const DISLIKES_STORAGE_KEY = 'DISLIKE_MATERIALS';

export default {
  name: 'MaterialLike',
  props: {
    material: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    like: false,
    dislike: false,
  }),
  mounted() {
    const likeMaterials = JSON.parse(localStorage.getItem(LIKES_STORAGE_KEY) || '[]');
    if (likeMaterials.includes(this.material.id)) {
      this.like = true;
    }

    const dislikeMaterials = JSON.parse(localStorage.getItem(DISLIKES_STORAGE_KEY) || '[]');
    if (dislikeMaterials.includes(this.material.id)) {
      this.dislike = true;
    }
  },
  methods: {
    /**
     *
     * @param type - like or dislike
     * @param reaction - add or remove
     */
    saveReaction(type, reaction) {
      const storageKey = type === 'like' ? LIKES_STORAGE_KEY : DISLIKES_STORAGE_KEY;
      let list = JSON.parse(localStorage.getItem(storageKey) || '[]');

      if (reaction === 'add') {
        list.push(this.material.id);
      } else if (reaction === 'remove') {
        list = list.filter((id) => this.material.id !== id);
      }

      localStorage.setItem(storageKey, JSON.stringify(list));
    },

    async setLike() {
      if (this.like) {
        await this.removeLike();
        return;
      }

      if (this.dislike) {
        await this.removeDislike();
      }

      const response = await this.$api.manageReactionPublicMaterial(this.material.id, 'like', 'add');
      if (response.success) {
        this.like = true;
        this.saveReaction('like', 'add');
      }
    },

    async setDislike() {
      if (this.dislike) {
        await this.removeDislike();
        return;
      }

      if (this.like) {
        await this.removeLike();
      }

      const response = await this.$api.manageReactionPublicMaterial(this.material.id, 'dislike', 'add');

      if (response.success) {
        this.dislike = true;
        this.saveReaction('dislike', 'add');
      }
    },

    async removeLike() {
      const response = await this.$api.manageReactionPublicMaterial(this.material.id, 'like', 'remove');

      if (response.success) {
        this.like = false;
        this.saveReaction('like', 'remove');
      }

      return response;
    },

    async removeDislike() {
      const response = await this.$api.manageReactionPublicMaterial(this.material.id, 'dislike', 'remove');

      if (response.success) {
        this.dislike = false;
        this.saveReaction('dislike', 'remove');
      }

      return response;
    },
  },
};
</script>

<style scoped lang="scss">

.material-like {
  display: flex;
  align-items: center;
  gap: calc(var(--scale) * 2);

  @include media-down($size-mobile) {
    flex-wrap: wrap;
  }

  h5 {
    margin-right: calc(var(--scale) * 38);
    font-weight: 500;
    font-size: calc(var(--scale) * 26);
    line-height: 120%;
    color: #02120F;

    @include media-down($size-tablet) {
      font-size: calc(var(--scale) * 18);
      margin-right: calc(var(--scale) * 10);
    }

    @include media-down($size-mobile) {
      width: 100%;
      margin-bottom: calc(var(--scale) * 10);
      margin-right: 0;
    }
  }

  button {
    display: flex;
    align-items: center;
    gap: calc(var(--scale) * 2);
    height: calc(var(--scale) * 39);
    padding-inline: calc(var(--scale) * 15) calc(var(--scale) * 9);
    border: 1px solid #CACACB;
    border-radius: calc(var(--scale) * 40);
    transition: 200ms;
    padding-bottom: calc(var(--scale) * 2);

    font-weight: 500;
    font-size: calc(var(--scale) * 14);
    color: #02120F;

    &.material-like__like {
      img {
        height: calc(var(--scale) * 24);
        filter: invert(94%) sepia(13%) saturate(4766%) hue-rotate(281deg) brightness(102%) contrast(89%);
      }

      &.active {
        background-color: #FFCEE2;
        border-color: #FFCEE2;

        img {
          filter: invert(11%) sepia(57%) saturate(6116%) hue-rotate(305deg) brightness(92%) contrast(89%)
        }
      }
    }

    &.material-like__dislike {
      img {
        height: calc(var(--scale) * 18);
      }

      &.active {
        background-color: #E6CEFF;
        border-color: #E6CEFF;
      }
    }
  }
}

</style>
